var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-template_input" },
    [
      _c(
        "el-input",
        _vm._b(
          {
            key: _vm.type,
            ref: "input",
            attrs: {
              value: _vm.value,
              placeholder: _vm.placeholder,
              min: 1,
              max: _vm.max,
              type: _vm.type,
              disabled: _vm.disabled,
              clearable: _vm.clearable,
              maxlength: _vm.maxlength,
              autofocus: _vm.autofocus,
            },
            on: {
              input: _vm.onInput,
              change: _vm.onChange,
              clear: _vm.onClear,
              focus: _vm.onFocus,
              blur: _vm.onBlur,
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onKeyupEnter.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "suffix",
                  fn: function () {
                    return [_vm._t("suffix")]
                  },
                  proxy: true,
                },
                {
                  key: "prepend",
                  fn: function () {
                    return [_vm._t("prepend")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          "el-input",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }